import { getYesOrNo } from "../projectConfiguration";

export const apiField = 'domestic_content'

const config = {
    label: 'isDomesticContent',
    type: 'Select',
    apiField,
    missing: undefined,
    data: getYesOrNo()
};

export default config;
